import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import api_rest from '../api_rest';
import { Observable, from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
// Modelos
import { Token } from "./../../models/Token";

@Injectable({
  providedIn: 'root'
})
export class OnedriveService {

  API_RUTA = "auth";
  API_URI = api_rest.server.API_URI_TI;
  API_URI_ALL = this.API_URI + '/' + this.API_RUTA;
  private readonly GRAPH_API = 'https://graph.microsoft.com/v1.0';

  constructor(private http: HttpClient) { }

  getTokenOneDrive(proyecto: number, jobcargaarchivo: number, tipoConexion: string, idConexion: string): Promise<Token> {
    const endPoint: string = "credentialsOneDrive";
    /* const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    }); */
    const body = { proyecto, jobcargaarchivo, tipoConexion, idConexion };
    return this.http.post<Token>(`${this.API_URI_ALL}/${endPoint}`, body).toPromise();
  }

  getFileFromOneDrive(
    idUserOneDrive: string, 
    ruta: string, 
    fileName: string, 
    accessToken: string
  ): Observable<Blob> {
    const encodedPath = ruta//encodeURIComponent(ruta);
    const encodedFile = fileName//encodeURIComponent(fileName);
    const fileUrl = `${this.GRAPH_API}/users/${idUserOneDrive}/drive/root:/${encodedPath}/${encodedFile}`;
  
    ////console.log('URL para consumir OneDrive', fileUrl); 
    ////console.log('Access Token', accessToken); 
  
    // Convertimos la primera llamada a Observable
    return from(
      fetch(fileUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      })
    ).pipe(
      // Verificamos si la respuesta es OK
      switchMap(response => {
        if (!response.ok) {
          console.error("Error al obtener metadatos del archivo");
          throw new Error('Error al obtener metadatos del archivo');
        }
        return from(response.json());
      }),
      // Obtenemos la URL de descarga
      switchMap(fileMetadata => {
        if (!fileMetadata || !fileMetadata['@microsoft.graph.downloadUrl']) {
          throw new Error('El archivo no tiene URL de descarga disponible');
        }
        
        // Convertimos la descarga a Observable
        return from(
          fetch(fileMetadata['@microsoft.graph.downloadUrl'], {
            method: 'GET'
          })
        );
      }),
      // Verificamos la respuesta de descarga
      switchMap(downloadResponse => {
        if (!downloadResponse.ok) {
          throw new Error('Error al descargar el contenido del archivo');
        }
        return from(downloadResponse.blob());
      }),
      // Manejo de errores
      catchError(error => {
        console.error('Error en getFileFromOneDrive:', error);
        throw error; // O puedes retornar un observable con error: throwError(error)
      })
    );
  }
}